import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import toast from "react-hot-toast";
import {
  createBlogTagsApi,
  deleteBlogTagsApi,
  getContactInquiryAPi,
} from "../helper/api_helper";
const ContactInquiry = () => {
  const [categories, setCategories] = useState([]);
  const [showAddGuardModal, setShowAddGuardModal] = useState(false);
  const [newGuard, setNewGuard] = useState({
    categoryName: "",
    id: "",
    message: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isPageLoading, setIsPageLoading] = useState(false);

  const getAllBlogCategories = async () => {
    try {
      setIsPageLoading(true);
      const response = await getContactInquiryAPi();

      console.log(response.data);
      setCategories(response.data);
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch categories");
      setCategories([]);
    } finally {
      setIsPageLoading(false);
    }
  };

  useEffect(() => {
    getAllBlogCategories();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); 
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  console.log("Categories ::", categories);

  const filteredBooking = categories?.filter((categories) => {
    const search = searchTerm?.toLowerCase();

    return Object.entries(categories)
      .filter(([key]) =>
        ["name", "phoneNumber", "email", "message","reason","country"].includes(key)
      )
      .some(([_, value]) => String(value)?.toLowerCase().includes(search));
  });

  const [currentPage, setCurrentPage] = useState(1);

  const [itemsPerPage] = useState(8);
  const totalItems = categories?.length || 0;
  const itemsPerPageSafe = itemsPerPage || 1;
  const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
  const startIdx = (currentPage - 1) * itemsPerPage;
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Contact Inquiry" />

      <div className="col-lg-12">
        <div className="card">
          <div
            className="card-header"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <form className="navbar-search d-flex align-items-center gap-2">
              <input
                type="text"
                className="bg-base h-40-px w-auto form-control"
                name="search"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Icon icon="ion:search-outline" className="icon" />
            </form>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {isPageLoading ? (
                <div className="text-center py-40">
                  <div
                    className="spinner-border"
                    role="status"
                    style={{ color: "black" }}
                  />
                </div>
              ) : filteredBooking?.length === 0 ? (
                <div className="text-center py-40 text-muted fw-medium">
                  No Contact Inquiry found.
                </div>
              ) : (
                <table className="table basic-border-table mb-0">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Name</th>
                      <th>Phone Number</th>
                      <th>Email</th>
                      <th>Country</th>
                      <th>Reason</th>
                      <th>Message</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredBooking
                      ?.slice(startIdx, startIdx + itemsPerPage)
                      ?.map((items, index) => (
                        <tr key={index}>
                          <td>{formatDate(items.createdAt)}</td>
                          <td>{items.name}</td>
                          <td>{items.phoneNumber}</td>
                          <td>{items.email}</td>
                          <td>{items.country}</td>
                          <td>{items.reason}</td>
                          <td>{items.message}</td>
                          <td className="text-center">
                            <div className="d-flex align-items-start gap-10 justify-content-start">
                              <button
                                type="button"
                                className="bg-info-focus text-info-600 bg-hover-info-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                onClick={() => {
                                  setIsEditing(true);
                                  setShowAddGuardModal(true);
                                  setNewGuard({
                                    categoryName: items.tag_name,
                                    id: items.id,
                                    message: items.message,
                                  });
                                }}
                              >
                                <Icon icon="lucide:eye" className="menu-icon" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            </div>

            {filteredBooking?.length > itemsPerPage && (
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24 mb-10">
                <span>
                  Showing {startIdx + 1} to{" "}
                  {Math.min(startIdx + itemsPerPage, filteredBooking?.length)}{" "}
                  of {filteredBooking?.length} entries
                </span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <Icon icon="ep:d-arrow-left" className="text-xl" />
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, index) => (
                    <li className="page-item" key={index}>
                      <button
                        className={`page-link ${
                          currentPage === index + 1
                            ? "bg-primary-600 text-white"
                            : "bg-primary-50 text-secondary-light"
                        } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                        onClick={() => goToPage(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}

                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <Icon icon="ep:d-arrow-right" className="text-xl" />
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      {showAddGuardModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div
              className="modal-dialog modal-md modal-dialog-centered"
              style={{ zIndex: 11122 }}
            >
              <div className="modal-content radius-16 bg-base">
                <div className="modal-header py-16 px-24 border-bottom">
                  <h1 className="modal-title fs-5">
                    {isEditing ? "View Message" : "Add Tag"}
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowAddGuardModal(false)}
                  />
                </div>

                <div className="modal-body p-24">
                  <form className="row g-3">
                    <div className="col-12">
                      <div className="border p-3 rounded text-muted bg-light">
                        {newGuard?.message || "No message available."}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div
              className="modal-backdrop fade show"
              style={{ zIndex: 1040 }}
            />
          </div>
        </>
      )}
    </MasterLayout>
  );
};

export default ContactInquiry;
